import { Type } from 'class-transformer';
import { IOrderFormChange } from './i-order-form';
import { PersistedOrder } from './persisted-order';

export const initialState: OrderState = Object.freeze({
  syncing: false,
  list: {},
});

export class OrderState {
  syncing: boolean;

  @Type(() => PersistedOrder)
  list: { [id: string]: PersistedOrder };

  formValues?: IOrderFormChange;
}
